import * as antIcons from '@ant-design/icons-vue'
import { upperFirst, camelCase } from 'lodash-es'

export function getAntIcon(icon: string) {
  const upperIcon = upperFirst(camelCase(icon))
  return antIcons[upperIcon]
}
